module.exports = __webpack_public_path__ + "img/confirmation1.aafe7632.svg";